export function sortArray(arr, sortKey = null, order = "asc") {
  const sign = order === "asc" ? 1 : -1;

  return arr.sort((a, b) => {
    let elementA = a;
    let elementB = b;

    if (
      (typeof elementA === "object" && !Array.isArray(elementA)) ||
      (typeof elementB === "object" && !Array.isArray(elementB))
    ) {
      elementA = a[sortKey];
      elementB = b[sortKey];
    }

    if (elementA > elementB) return 1 * sign;
    else if (elementA < elementB) return -1 * sign;
    else return 0;
  });
}
